import { useInstallPrompt } from '../lib/install.js';

/**
 * Convite para instalar, no /inicio.
 *
 * Aparece uma vez e é dispensável — quem já disse não não precisa ouvir de
 * novo a cada abertura. Em modo standalone some, porque já está instalado.
 */
export function InstallCard() {
  const { hint, install, dismiss } = useInstallPrompt();

  if (hint === 'none') return null;

  return (
    <section className="install-card">
      <div>
        <strong>Instalar no celular</strong>
        {hint === 'prompt' ? (
          <small>
            Abre em tela cheia, sem a barra do navegador, e aparece junto dos seus apps.
          </small>
        ) : (
          <small>
            Toque em <strong>Compartilhar</strong> e depois em{' '}
            <strong>Adicionar à Tela de Início</strong>.
          </small>
        )}
      </div>

      <div className="install-actions">
        {hint === 'prompt' ? (
          <button type="button" className="btn primary" onClick={() => void install()}>
            Instalar
          </button>
        ) : null}
        <button type="button" className="btn" onClick={dismiss}>
          Agora não
        </button>
      </div>
    </section>
  );
}
